import { qweGuid } from "../../../common/commonHelper";
import qweBaseField from "../BaseField";
import { read, utils } from "xlsx";
import dayjs from "../../../utils/dayjs"


export default {
    mixins:[qweBaseField],
    data:function(){
        return {
            isInlineEdit:false,
            gridDefinition:[],
            OriginalDefinition:[],
            originalFlowDefinition:[],
            subform:"",

            dialogVisible:false,
            
            currentColumonName:"",
            
            uploadId:"",

            pcStickyColumn: {
                "Switch": false,
                "Number": 0
            },

            operateState:false,
            pushImport:true,

            selectItemIds:[],
            loadingItems:false,

            newName:"",
            excelName:"",
            batchDeleteName:"",

            currentpage:1,
            pagesize:20,

            showAll:false,

            propDatas:{
                ContentType:"",
                ContentTypeDefinition:[],
                Data:{},
                ComputeFlowDefinition:false,
                FlowDefinition:[],
                ParentData: {},
                CheckIn:[]
            },

            subFormDownmoon:[],

            showSummary:false,
            summaryFields:[]
        }
    },
    created:function(){
        this.uploadId = qweGuid(10);
        this.isInlineEdit = this.selfSetting.IsInlineEdit;
        this.showAll = this.selfSetting.ShowAll;

        let gridDefinition = JSON.parse(this.selfSetting.FieldsString);
        
        this.OriginalDefinition = JSON.parse(this.selfSetting.FieldsString);
       
        let FlowDefinition = new Array();

        if(this.formDefinition[this.name].SubformSettings != null && this.formDefinition[this.name].SubformSettings != undefined){
            FlowDefinition = this.formDefinition[this.name].SubformSettings;
        }
        else{
            this.OriginalDefinition.forEach(x=>{
                if(this.formDefinition.hasOwnProperty(x.Name)){
                    FlowDefinition.push(this.formDefinition[x.Name])
                }
            });
        }


        this.originalFlowDefinition = JSON.parse(JSON.stringify(FlowDefinition));

        this.propDatas.ParentData = this.data;
        //定义中不显示的字段也不在当前数据展示
        gridDefinition = gridDefinition.filter(x => {
            return x.Settings.FieldCommonSetting.IsDisplay;
        });

        let formDefinitionObject = {};
        FlowDefinition.forEach(x=>{
            formDefinitionObject[x.Name] = x;
        })
        //定义中不显示在当前阶段的字段过滤掉
        gridDefinition = gridDefinition.filter(x => {
            if (formDefinitionObject.hasOwnProperty(x.Name)) {
                return !formDefinitionObject[x.Name].IsHidden;
            }
            else {
                return false;
            }
        });

        let gridFields = this.selfSetting.GridFields || [];
        if(gridFields.length > 0){
            gridDefinition = gridDefinition.filter(x=> gridFields.includes(x.Name));
            gridDefinition.sort((prev, next) => {
                const p = gridFields.indexOf(prev.Name)
                const n = gridFields.indexOf(next.Name)
                return p - n
            })
        }

        this.propDatas.CheckIn = this.selfSetting.CheckIn ||[];
        this.gridDefinition = gridDefinition;

        this.subform = this.name + "subform";

        if (this.selfSetting.hasOwnProperty("PcStickyColumn")) {
            this.pcStickyColumn.Switch = this.selfSetting.PcStickyColumn.Switch;
            this.pcStickyColumn.Number = this.selfSetting.PcStickyColumn.Number;
        }


        this.subFormDownmoon = this.selfSetting.SubFormDownmoon || [];
        this.showSummary = this.selfSetting.ShowSummary;
        this.summaryFields = this.selfSetting.SummaryFields || [];
    },

    computed:{
        valueString: function () {
            return JSON.stringify(this.data[this.name]);
        },

        subformCreate:function(){
            return this.formDefinition[this.name].SubformCreate;
        },

        subformDelete:function(){
            return this.formDefinition[this.name].SubformDelete;
        },

        showTableData:function(){
            let tableData = this.data[this.name] || [];
            if(!this.showAll){
                let startIndex = (this.currentpage -1) * this.pagesize;
                let endIndex = startIndex + this.pagesize > tableData.length ? tableData.length : startIndex + this.pagesize;
                return tableData.slice(startIndex, endIndex);
            }
            else{
                return tableData;
            }
        }
    },

    methods:{
        buildRequiredRule:function(){
            let validatePass = (rule, value, callback) => {
                if (value === null || value === undefined) {
                    callback(new Error(this.displayName + "至少需要添加一条数据"));
                } 
                else {
                    if(value.length == 0){
                        callback(new Error(this.displayName + "至少需要添加一条数据"));
                    }
                }
                callback();
            };
            return {
                validator: validatePass,  trigger: 'blur', required: true
            };
        },

        formatter: function (type, row, column, cellValue, index) {
            if (type === "DateField") {
                return dayjs(cellValue).isValid() ? dayjs(cellValue).format("YYYY-MM-DD") : "" ;
            }
            if (type === "BooleanField") {
                if (cellValue) {
                    return "是";
                }
                else {
                    return "否";
                }
            }
            if (type === "AttachFileField" || type === "ImageField") {
                let temp = "";
                (cellValue || []).forEach(cell => {
                    temp = temp + `<a href='${cell.url}'>${cell.name}</a>`;
                });
                return temp;
            }
            if(type === "ComputedObjectField"){
                return JSON.stringify(cellValue);
            }
            return cellValue;
        },
        
        getSummaries:function({ columns, data }){
            let summary = new Array();
            columns.forEach((x,index)=>{
                let Property = x.property;
                if(!this.summaryFields.includes(Property)){
                    if(x.type == "index"){
                        summary[index] = "总计";
                        return;
                    }
                    else{
                        summary[index] = "";
                        return;
                    }
                }
                else{
                    let values = data.map((item) => Number(item[Property]));
                    if (!values.every((value) => Number.isNaN(value))) {
                        let total = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!Number.isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        summary[index] = total
                        return;
                    } 
                    else{
                        summary[index] = "";
                        return;
                    }
                }
            })
            
            return summary;
        },

        beforeUpload:function(state){
            this.pushImport = state;
            document.getElementsByName(this.uploadId)[0].click();
        },

        importByExcel:function (e) {
            let that = this;
            let files = e.target.files;
            if(files.length == 0){
                return;
            }
            let f = e.target.files[0];
            var reader = new FileReader();
            if (f.name.search("xls") > -1 || f.name.search("xlsx") > -1) {
                reader.onload = function (file) {
                    var data = new Uint8Array(file.target.result);
                    var wb = read(data, { type: 'array', cellDates: true });
                    if(wb.SheetNames.length > 1){
                        that.$message.error("导入失败！当前excel包含多个工作表，请检查是否隐藏工作表或者将需要导入数据的工作表放置第一个")
                        return;
                    }
                    let result = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                    if(result.length>0){
                        let keys = new Array();
                        let keyToValues = {};
                        that.OriginalDefinition.forEach(x=> {
                            keyToValues[x.Settings.ContentPartFieldSettings.DisplayName] = x.Name
                            keys.push(x.Settings.ContentPartFieldSettings.DisplayName);
                        })
                        result = result.map(x=>{
                            let obj = {};
                            keys.forEach(key=>{
                                if(keyToValues[key] != undefined){
                                    obj[keyToValues[key]] = x[key];
                                }
                            })
                            return obj
                        });
                        that.importData(result);
                        that.clearFile(e.target);
                    }
                    
                };
                reader.readAsArrayBuffer(f);
            }
            else if (f.name.search("csv") > -1) {
                reader.onload = function (event) {
                    let dataText = event.target.result;
                    let dataArray = new Array();
                    if (dataText.search("\n")) {
                        dataArray = dataText.split("\r\n");
                    }
                    else {
                        dataArray = dataText.split("\r");
                    }
                    let result = new Array();
                    let keys = new Array();
                    dataArray.forEach((x, index) => {
                        if (index === 0) {
                            keys = x.split(",").map(key => key.replace(new RegExp(" ", "gm"), "")).filter(key => key !== "");
                        } else {
                            if (x.length > 0) {
                                let resultItemArray = x.split(",");
                                let resultItem = {};
                                keys.forEach((key, keyIndex) => {
                                    resultItem[key] = resultItemArray[keyIndex].trim();
                                });
                                result.push(resultItem);
                            }
                        }
                    });
                    that.importData(result);
                    that.clearFile(e.target);
                };
                reader.readAsText(f);
            }
            
        },

        clearFile:function(e){
            e.value = "";
        },

        importData:function(data){
            let result = [];
            if (this.pushImport) {
                result = (this.data[this.name] || []).concat(data);
            }
            else {
                result = data;
            }
            this.setData(result);
        },

        setValueBeforeHook:function(value){
            value = (value || []).filter(x=> x != undefined || x != null);
            value.forEach(x=>{
                if(!x.hasOwnProperty("QweGuid")){
                    x.QweGuid = qweGuid(26);
                }
            });
            return value;
        },

        newItem: function () {
            this.propDatas.FlowDefinition = this.originalFlowDefinition;
            this.propDatas.ContentTypeDefinition = this.OriginalDefinition;

            let data = {};
            (this.OriginalDefinition || []).forEach(x => {
                data[x.Name] = null;
            });

            if(this.subFormDownmoon.length > 0){
                this.subFormDownmoon.forEach(x=>{
                    data[x.TargetKey] = this.data[x.OriginalKey];
                })
            }
            data.QweGuid = qweGuid();
            this.propDatas.Data = data;
            this.dialogVisible = true;
        },

        allDelete:function(){
            let result = this.data[this.name].filter(x=> !this.selectItemIds.includes(x.QweGuid));
            this.setData(result);
        },

        handleSelectionChange:function(selection){
            this.selectItemIds = selection.map(x=> x.QweGuid);
        },

        updateSubmitForm:function(code,data){
            if(code == 200){
                let index = this.data[this.name].findIndex(x=>x.QweGuid == data.QweGuid);
                if(index >-1){
                    this.data[this.name][index] = data;
                }
                else{
                    this.data[this.name].push(data);
                }
                this.dialogVisible = false
            }
        },

        editRow:function(guid){
            this.propDatas.FlowDefinition = this.originalFlowDefinition;
            this.propDatas.ContentTypeDefinition = this.OriginalDefinition;
            let data = this.data[this.name].find(x=> x.QweGuid == guid);
            this.propDatas.Data = data;
            this.dialogVisible = true;
        }
    }
}